module.exports = __webpack_public_path__ + "media/img/city_bcg-516d35e2.png";